var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3922 6.25312C19.2797 5.83125 19.2047 5.59688 19.2047 5.59688C19.0828 5.16094 18.7734 5.16094 18.3141 5.08594L15.825 4.77188C15.5156 4.72031 15.5156 4.72031 15.3938 4.45312C14.9859 3.53437 14.8594 3 14.4141 3H9.58594C9.14063 3 9.01875 3.53437 8.61094 4.45781C8.48906 4.72031 8.48906 4.72031 8.17969 4.77656L5.68594 5.09062C5.23125 5.16562 4.90313 5.20781 4.78125 5.64375C4.78125 5.64375 4.725 5.83594 4.60781 6.25312C4.45781 6.81094 4.39688 6.75 4.9125 6.75H19.0875C19.6031 6.75469 19.5469 6.81094 19.3922 6.25312Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7844 8.25H6.21563C5.4375 8.25 5.4 8.35312 5.44688 8.93906L6.32344 20.3109C6.39844 20.8875 6.45469 21.0047 7.14375 21.0047H16.8563C17.5453 21.0047 17.6016 20.8875 17.6766 20.3109L18.5531 8.93906C18.6 8.34844 18.5625 8.25 17.7844 8.25Z",
    fill: "#AFAFAF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.c1be6fe37f68d518159df5f8ce36cf28.svg";
export { ForwardRef as ReactComponent };